import * as utils from '../utils/utils';

/**
* Initialises the component when passed an element.
*
* @param {HTMLNode} rootElement The component dom node
*/
export default function(rootElement) {
  if (!rootElement) {
    return;
  }

  const v2 = rootElement.dataset.v2 === 'true';
  const protocol = utils.isSecure() ? 'https://secure.' : 'http://';

  if (v2) {
    utils.loadScript(`${protocol}widget.cloud.opta.net/2.0/js/widgets.opta.js`);
    utils.loadStylesheet(`${protocol}widget.cloud.opta.net/2.0/css/widgets.opta.css`);
    return;
  }

  const isOlympicsWidget = rootElement.dataset.isOlympicsWidget === 'true';

  if (isOlympicsWidget) {
    const widgetId = rootElement.dataset.olympicsWidgetId;
    utils.loadScript('https://widgets-assets.stats.com/shs-widgets/js/core.min.js');
    utils.loadScript(`https://widgets-assets.stats.com/js/oly-olympic-${widgetId}.min.js`);
    utils.loadStylesheet(`https://widgets-assets.stats.com/css/widgets-oly-olympic-${widgetId}.min.css`);
    return;
  }

  utils.loadScript(`${protocol}widget.cloud.opta.net/v3/v3.opta-widgets.js`);

  let optaStylesheet = '';
  switch (rootElement.dataset.sport) {
  case 'football':
    optaStylesheet = 'football';
    break;
  case 'cricket':
    optaStylesheet = 'cricket';
    break;
  default:
    optaStylesheet = 'all';
  }

  utils.loadStylesheet(`${protocol}widget.cloud.opta.net/v3/css/v3.${optaStylesheet}.opta-widgets.css`);
}
